<!--  -->
<template>
    <div class="school">
        <div class="sycn_cuorse">
            <div class="title">同步课堂</div>
            <span class="introduce">一周一课</span>
            <span class="introduce">基于优质课堂辐射的京蒙两地同步直播</span>
            <div class="coutent">
                <div class="rili">
                    <div class="calendar">
                        <div class="month">
                            <div class="menu">
                                <i class="el-icon-caret-left" @click="prevMonth"></i>
                                <span>{{ date.getFullYear() }}年{{ date.getMonth() + 1 }}月</span>
                                <i class="el-icon-caret-right" @click="nextMonth"></i>
                            </div>
                        </div>
                        <el-calendar v-model="date">
                            <template slot="dateCell" slot-scope="{date, data}">
                                <div class="content" @click="onDateChange(data.day)">
                                    <img class="green" src="../assets/home/green.png" alt=""
                                        v-if="courseObj.hasOwnProperty(data.day)">
                                    <span class="day">{{ data.day.split('-').slice(1)[1] }}</span>
                                    <template v-if="courseObj.hasOwnProperty(data.day)">
                                        <div class="course_item" v-for="(item, index) in courseObj[data.day]" :key="index"
                                            @click="goCourse(item.courseProjectId)">
                                            <img class="yellow" src="../assets/home/yellow.png" alt="">
                                            <el-tooltip placement="right" popper-class="myTooltip">
                                                <span class="name">{{ item.lessonsName }}</span>
                                                <div slot="content" class="tip_box">
                                                    <div class="time">
                                                        <span>{{ item.lessonsBeginDate }}</span>
                                                        <span>共<span class="blue">{{ courseObj[data.day].length
                                                        }}节</span>课</span>
                                                    </div>
                                                    <span class="name">{{ item.lessonsName }}</span>
                                                    <div class="teaInfo">
                                                        <img src="../assets/home/avatar.png" alt="">
                                                        <span>主讲教师:{{ item.teacherName }}</span>
                                                        <div class="status">{{ courseStatur[item.status] }}</div>
                                                    </div>
                                                </div>
                                            </el-tooltip>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </el-calendar>
                    </div>
                </div>
                <div class="list">
                    <div class="date">
                        <span>{{ currentDay }}</span>
                        <span>共{{ syncCourseList.length }}节课</span>
                    </div>
                    <template v-if="syncCourseList.length > 0">
                        <div class="item" v-for="(item, index) in syncCourseList" :key="index">
                            <img src="../assets/images/course.png" alt="" class="badge" v-if="item.lessonsPattern == 0">
                            <img src="../assets/images/async.png" alt="" class="badge" v-else>
                            <div class="time">
                                <span>{{ item.lessonsBeginDate }}</span>
                                <div class="status">未开始</div>
                            </div>
                            <span class="name">{{ item.lessonsName }}</span>
                            <div class="info">
                                <img src="../assets/images/avatar.png" alt="">
                                <span>主讲教师:{{ item.teacherName }}</span>
                            </div>
                        </div>
                    </template>
                    <el-empty description="暂无数据" v-else style="margin-top: 150px;"></el-empty>
                </div>
            </div>
        </div>
        <div class="sync_chengzhang" style="margin-top: 0;">
            <template v-if="courseList.length > 0">
                <div class="course">
                    <div class="course_item" v-for="(item, index) in courseList" :key="index" @click="goCourse(item.id)">
                        <img :src="imgurl + item.cover" alt :onerror="$store.state.course.defaultCourseCover[index % 5]" />
                        <div class="course_name wes">{{ item.name }}</div>
                        <span class="course_time">上课时间：{{ item.timeScope }}</span>
                        <div class="course_time">主讲老师：{{ item.teacherName }}</div>
                    </div>
                    <div class="course_item_empty" v-for="(item, index) in 3" :key="index" @click="goCourse(item.id)">
                    </div>
                </div>
                <div class="more" @click="gocurriculumPublic" v-if="courseTotal > 8">更多</div>
            </template>

            <el-empty description="暂无课程" v-else></el-empty>
        </div>
        <!-- <Login2 v-if="showLogin" :courseId='courseId'></Login2> -->
        <Login3 v-if="showLogin" @getUserinfo="getUserinfo"></Login3>
    </div>
</template>
<script>
import { EventBus } from './eventBus';
export default {
    data() {
        return {
            imgurl: 'https://yun.cnuen.net/api/fu/front/upload/download?identifier=',
            syncCourseList: [],
            courseList: [],
            date: new Date(),
            currentDay: new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0'),
            courseObj: {},
            courseStatur: {
                unstart: "未开始",
                start: "上课中",
                end: "已下课"
            },
            courseId: null,
            showLogin: false,
            courseTotal:0
        }
    },
    methods: {
        getList() {
            let data = {
                page: 1,
                limit: 10,
                projectId: 266
            }
            Api.Home.GetCloudCourse(data)
                .then(res => {
                    console.log('课程:', res);
                    // this.courseList.push(res.data.records[4]);
                    this.getList2()
                })
                .catch(err => {
                    console.log('err:', err)
                })
        },
        getList2() {
            let data = {
                page: 5,
                limit: 7,
                projectId: 266
            }
            Api.Home.GetCloudCourse(data)
                .then(res => {
                    // console.log('getList2课程:', res);
                    this.courseList = this.courseList.concat(res.data.records)
                })
                .catch(err => {
                    console.log('err:', err)
                })
        },
        prevMonth() {
            let currentDate = this.date;
            let currentMonth = currentDate.getMonth();
            this.date = new Date(currentDate.getFullYear(), currentMonth - 1, 1);
            this.getCourse()
        },
        nextMonth() {
            let currentDate = this.date;
            let currentMonth = currentDate.getMonth();
            this.date = new Date(currentDate.getFullYear(), currentMonth + 1, 1);
            this.getCourse()
        },
        //  Api.Home.getNews(params)
        getCourse() {
            // 获取当前时间
            let currentDate = this.date;
            // 获取年份
            let year = currentDate.getFullYear();
            // 获取月份（注意月份从0开始，所以需要加1）
            let month = currentDate.getMonth() + 1;
            // 获取日期
            let day = currentDate.getDate()
            // 格式化年份和月份
            let formattedDate = `${year}-${month.toString().padStart(2, '0')}`;
            let data = {
                month: formattedDate,
                // projectId: 266
                projectId: 390
            };
            Api.Home.GetTimetable(data)
                .then(res => {
                    // console.log('课程表:', res);
                    this.courseObj = res.data;
                    // console.log(res.data['2023-08-04'])
                })
                .catch(err => {
                    console.log('获取课程表失败:', err)
                })
            this.getCourseDetailByDay(`${year}-${month.toString().padStart(2, '0')}-${day}`, false)
        },
        onDateChange(date) {
            // console.log('当前选择的日期是:', date);
            this.currentDay = date;
            this.getCourseDetailByDay(date, true)
        },
        // 获取课程表某一天的数据
        getCourseDetailByDay(day, boole) {
            let data = {
                day,
                projectId: 390
            }
            Api.Home.GetCloudCourseByDay(data)
                .then(res => {
                    // console.log('获取课程表某一天的数据', res);
                    this.syncCourseList = res.data;
                    if (boole) {
                        if (res.data.length > 0) {
                            // window.open("https://jm.cnuen.net/login")
                            // 跳转京蒙研修
                            let access_token = sessionStorage.getItem('token');
                            let member = sessionStorage.getItem('member')
                            // window.open(`https://jm.cnuen.net/login?origin=cnueb&access_token=${access_token}&member=${member}&courseId=${this.courseId}&projectId=266&goPath=course`)
                        }
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        goCourse(id) {
            this.courseId = id;
            //
            // this.$store.commit('isDisplayLogin', true);
            // console.log('access_token:', sessionStorage.getItem('token'));
            if (!sessionStorage.getItem('token')) {
                this.showLogin = true;
                this.$store.commit('isDisplayLogin', true);
            } else {
                let access_token = sessionStorage.getItem('token');
                let member = sessionStorage.getItem('member')
                window.open(
                    `https://jm.cnuen.net/login?origin=cnueb&access_token=${access_token}&member=${member}&courseId=${this.courseId}&projectId=390&goPath=course`
                )
            }
        },
        getUserinfo() {
            // console.log('组件通信');
            EventBus.$emit('test', 'Hello from ComponentA')
        },
        gocurriculumPublic() {
            this.$router.push({
                path: 'curriculumPublic',
                query: {
                    markType: 2,
                    'breadNumber': 2,
                }
            })

        },
        //课程列表请求
        async getCourselist() {
            let data = {
                markId: 2,
                page: 1,
                limit: 8,
                orderType: 0,
                name: ''
            }
            let resData = await Api.Curriculum.getCourselist(data);
            console.log('同步课堂推荐:', resData);
            this.courseList = resData.data.records;
            this.courseTotal = resData.data.total
        },
    },
    mounted() {
        // this.getList();
        this.getCourselist()
        this.getCourse()
    },
};
</script>
<style lang='less' scoped>
@import url('./less/school.less');
</style>